<template>
  <div class="welcome-ba-page">
    <div class="p-relative header-image pb-5"></div>

    <b-container class="custom-container mt-5">
      <b-row>
        <b-col cols="12" class="px-3">
          <b-container fluid>
            <b-row>
              <b-col cols="12">
                <h4 class="font-weight-bold pt-4 mb-4 align-middle">
                  Projects
                </h4>
                <b-card
                  border-variant="light"
                  bg-variant="light"
                  body-class="px-0 py-0"
                >
                  <project-list v-if="canViewProjects" />
                  <permission-notice
                    v-else
                    message="You don't have permission to view projects."
                  />
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>

      <!-- v-show (not v-if) on the count: TradieEndingCompanyAssociationList is
           the only thing that ever sets endingTradiesCount, via count-changed
           on mount. Gating its own existence behind that count would mean it
           never mounts, never fetches, and the count could never leave 0 -->
      <b-row v-if="canViewTradies" v-show="endingTradiesCount > 0">
        <b-col cols="12" class="px-3">
          <b-container fluid>
            <b-row>
              <b-col cols="12">
                <h4 class="font-weight-bold pt-4 mb-4 align-middle">
                  Tradies Ending Company Association
                </h4>
                <b-card
                  border-variant="light"
                  bg-variant="light"
                  body-class="px-0 py-0"
                >
                  <TradieEndingCompanyAssociationList
                    @count-changed="endingTradiesCount = $event"
                  />
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" class="px-3">
          <b-container fluid>
            <b-row>
              <b-col cols="12">
                <h4 class="font-weight-bold pt-4 mb-4 align-middle">
                  Expiring Soon (in 30 days)
                </h4>
                <b-card
                  border-variant="light"
                  bg-variant="light"
                  body-class="px-0 py-0"
                >
                  <expiring-tradie-list
                    v-if="canViewTradies"
                    from-context="expiring-home"
                  />
                  <permission-notice
                    v-else
                    message="You don't have permission to view tradies."
                  />
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProjectList from '@/components/lists/ProjectList'
import ExpiringTradieList from '@/components/lists/ExpiringTradieList'
import TradieEndingCompanyAssociationList from '@/components/lists/TradieEndingCompanyAssociationList.vue'
import PermissionNotice from '@/components/PermissionNotice.vue'

export default {
  components: {
    ProjectList,
    ExpiringTradieList,
    TradieEndingCompanyAssociationList,
    PermissionNotice,
  },
  data() {
    return {
      endingTradiesCount: 0,
    }
  },
  computed: {
    ...mapGetters('auth', ['hasPermission']),
    canViewProjects() {
      return this.hasPermission('projects.view')
    },
    canViewTradies() {
      return this.hasPermission('tradies.view')
    },
  },
}
</script>

<style lang="scss" scoped>
/* The fixed navbar wraps to two rows on small screens (taller than the desktop
   navbar the page clearance is sized for), so the "Projects" title is cramped
   against it — add extra top spacing on phones/tablets. */
@media (max-width: 767.98px) {
  .welcome-ba-page {
    padding-top: 0.5rem;
  }
}
</style>
